<template>
    <!-- Start Main Content -->
    <div
        class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div
            class="card p-0 lg:min-h-[calc(100vh_-_theme('spacing.header')_*_1.4)] xl:min-h-[calc(100vh_-_theme('spacing.header')_*_1.6)]">

            <div
                class="flex flex-col gap-2 sm:flex-center-between sm:flex-row px-2 py-2 sm:p-1 bg-gray-200/30 dark:bg-dark-card-shade">
                <div>
                    <h6 class="card-title">{{stitch_type_for==1?'Stiching Sale':'Regular Sale'}}</h6>
                </div>
                
                <label>Date : <input type="date" v-model="sale.date"></label>
            </div>

              <div  class = "mt-2" v-if="stitch_type_for == 1" style="margin-left: 10px;">
                <lable>Invoice Number</lable>
                      <input 
                                         
                                            type="number" 
                                            class="form-input" 
                                            v-model="invoice.invoice_no" 
                                            style="width: 10%;"
                                            readonly
                                           
                                        />
                </div>

            <div class="overflow-x-auto scrollbar-table px-1.5 py-4">
                <table class="table-auto w-full ">
                    <tbody>
                        <tr>
                            <td class="dark:text-white">Customer Name <a class="text-danger border px-4"
                                    @click="addModal()">
                                    <i class="ri-add-line text-danger text-[13px]"></i> Add New Customer <span>(F1)</span>
                                </a></td>
                            <td class="dark:text-white">Cell</td>
                            <td class="dark:text-white">Dob</td>
                            <td class="dark:text-white">Address</td>
                            <td class="dark:text-white">Balance</td>
                        </tr>
                        <tr>
                            <td class="prd_name_col"> <select class="form-input" id="cust_name" ref="cust_name"
                                    v-model="sale.custid" autofocus>
                                    <option v-for="(item ,index)  in customerList" :value="item.id">{{item.name+' '+item.cell}}</option>
                                </select></td>
                            <td class="prd_val_col">{{ sale.custcell }}</td>
                            <td class="prd_val_col">{{ sale.dob }}</td>
                            <td class="prd_val_col">{{ sale.custaddress }}</td>
                            <td :class="sale.balance>0 ? 'prd_val_col text-danger':'prd_val_col text-info'">{{sale.balance?parseInt(sale.balance):0 }}</td>
                        </tr>
                    </tbody>
                </table>

            </div>

            <!-- <div class="px-3.5 py-4">
                <label class="inline-flex items-center me-5 cursor-pointer">
                    Pcs Sale &nbsp;&nbsp;
                    <input type="checkbox" class="appearance-none peer" :checked="isSet" v-model="isSet"
                        v-on:input="isSet=!isSet">
                    <span class="switcher switcher-primary-solid"></span>
                    &nbsp;&nbsp;Set Sale
                </label>
            </div> -->
            <!-- Start All Language List Table -->
            <div class="p-3 sm:p-4">
                <div class="overflow-x-auto scrollbar-table">
                    <table
                        class="table-auto w-full whitespace-nowrap text-left text-gray-500 dark:text-dark-text leading-none">
                        <thead class="border-b border-gray-200 dark:border-dark-border font-semibold">
                            <tr class="bg-gray">
                                <th class="px-1.5 py-4 prd_val_col">Barcode</th>
                                <!--<th class="px-1.5 py-4 prd_val_col">HSN</th>-->
                                <th class="px-1.5 py-4 prd_name_col">Name</th>
                                <!--<th class="px-1.5 py-4">GST</th>-->
                                <th class="px-1.5 py-4 prd_val_col">Type</th>
                                <th class="px-1.5 py-4 prd_val_col ">Rate</th>
                                <th class="px-1.5 py-4 prd_val_col_x">Piece|Mtr|Qty</th>
                                <th class="px-1.5 py-4 prd_val_col right">Total</th>
                                <th class="px-1.5 py-4 px-4"> <i
                                        class="ri-settings-3-line text-inherit text-[13px]"></i></th>
                            </tr>
                        </thead>
                        <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                            <tr class="hover:bg-primary-200/50 dark:hover:bg-dark-icon hover:text-gray-500 dark:hover:text-white "
                                v-for="(item ,index)  in sale_product_list" :value="item.id" :ref="'selected_product'" tabindex="0"  v-on:keyup.enter="plusModal(index,item)">
                                <td class="dark:text-white">{{item.barcode }}</td>
                                <!--<td class="dark:text-white">{{item.hsn}}</td>-->
                                <!-- <td class="dark:text-white" @click="tagModal(index) ">{{item.prdname}}  <i class="ri-price-tag-3-line text-success text-[13px]"></i></td> -->
                                <td class="dark:text-white">
                                    {{ item.prdname }}
                                    <input v-if="stitch_type_for == 1" type="text" v-model="item.cat_name"/>
                                    <!--<i class="ri-price-tag-3-line text-success text-[13px]"-->
                                    <!--    @click="tagModal(index)"></i>-->
                                    <i class="ri-add-line text-blue-500 text-[13px] ml-2 cursor-pointer"
                                        @click="plusModal(index,item)"></i>
                                        
                                </td>


                                <!--<td class="dark:text-white text-center">{{item.gst}}</td>-->
                                <td class="dark:text-white ">
                                    <select class="form-input" id="" v-model="item.stich_type">

                                        <!-- <template v-for="(itemc ,index)  in product_cat" :key="itemc.id">
                                            <option v-if="item.stich_type==itemc.id" selected :value="itemc.id">
                                                {{itemc.name}}</option> -->
                                            <option  value="1">SHIRT</option>
                                            <option  value="2">PANT</option>
                                        <!-- </template> -->

                                    </select>
                                </td>
                              <td class="">
                                        <input 
                                            v-if="stitch_type_for == 1"
                                            type="number" 
                                            class="form-input right" 
                                            v-model="item.stich_rate"
                                            @input="getTotal_added(item)" 
                                        />

                                        <input 
                                            v-else
                                            type="number" 
                                            class="form-input right" 
                                            v-model="item.salerate"
                                            @input="getTotal_added(item)" 
                                        />
                                        </td>

                                <td class="" >
                                           <div style="    display: flex;">
                                     <input type="text" class="form-input text-center" ref="qty_mtr" v-model="item.qty_mtr"  
                                            >
                                     <input type="text" class="form-input  text-center" v-model="item.qty_unit" 
                                            >
                                    <input type="text" class="form-input  text-center" v-model="item.qty"
                                        @input="getTotal_added(item)" />
                                        </div>

                                </td>

                                <td class="right">{{item.total}}</td>
                                <td class="px-4">
                                    <div class="flex items-center gap-1">
                                        <button class="btn-icon btn-danger-icon-light size-7"
                                            @click="deleteModal(index)">
                                            <i class="ri-delete-bin-line text-danger text-[13px]"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>



                            <tr
                                class="hover:bg-primary-200/50 dark:hover:bg-dark-icon hover:text-gray-500 dark:hover:text-white entry_row">
                                <td class=""><input type="text" class="form-input" ref="barcode" id="barcode"
                                        v-model="prd.barcode" v-on:keyup.enter="getBarcode()"></td>
                                <!--<td class="">{{prd.hsn}}</td>-->
                                <td class="">
                                    <select class="form-input" id="prd_name" ref="name" v-model="prd.prdid">
                                        <option v-for="(item ,index)  in productsList" :value="item.id">{{item.name+' '+item.barcode}}</option>
                                    </select>

                                </td>
                                <!--<td class="">{{prd.gst}}</td>-->
                                <td class="">
                                      <select class="form-input" id="" v-model="prd.stich_type"  @change="setItemStichType(this)">

                                        <!-- <template v-for="(itemc ,index)  in product_cat" :key="itemc.id">
                                            <option v-if="item.stich_type==itemc.id" selected :value="itemc.id">
                                                {{itemc.name}}</option> -->
                                            <option  value="1">SHIRT</option>
                                            <option  value="2">PANT</option>
                                        <!-- </template> -->

                                    </select>

                                    <!-- <select class="form-input" id="stich_type" ref="stich_type" v-model="prd.stich_type"
                                        @change="setItemStichType(this)">
                                        <template v-for="(item ,index)  in product_cat" :key="item.id">
                                            <option v-if="prd.stich_type==item.id" selected :value="item.id">
                                                {{item.name}}</option>
                                            <option v-else :value="item.id">{{item.name}}</option>
                                        </template>
                                    </select> -->
                                </td>
                                <td class="">

                                     <input 
                                            v-if="stitch_type_for == 1"  v-on:keyup.enter="addToCart()"
                                            type="number" 
                                            class="form-input text-center" 
                                            v-model="prd.stich_rate"
                                            @input="getTotal()" 
                                        />

                                        <input 
                                            v-else
                                            type="number"   v-on:keyup.enter="addToCart()"
                                            class="form-input text-center" 
                                            v-model="prd.salerate"
                                            @input="getTotal()" 
                                        />
<!--                                         
                                    <input type="text" class="form-input text-center" ref="salerate"
                                        v-model="prd.salerate" @input="getTotal()" v-on:keyup.enter="addToCart()"> -->

                                </td>
                                <td class="">
                                    <div style="    display: flex;">
                                        <input type="text" class="form-input text-center" ref="qty_mtr" v-model="prd.qty_mtr"  @keyup.enter="focusQtyUnit" 
                                            @input="getQtyMtr()">
                                        <input type="text" class="form-input  text-center" v-model="prd.qty_unit" ref="qty_unit" v-on:keyup.enter="addToCart()" 
                                            @input="getQtyMtr()" >
                                        <input type="text" class=" form-input text-center" ref="qty" id="qty" 
                                            v-model="prd.qty" @input="getTotal()" v-on:keyup.enter="addToCart()">
                                    </div>

                                </td>
                                <td class=""><input type="text" class="form-input" v-model="prd.total"></td>
                                <td class="">
                                    <div class="flex items-center gap-1">
                                        <button class="btn-icon btn-primary-icon-light size-7" @click="addToCart()">
                                            <i class="ri-add-line text-inherit text-[13px]"></i>
                                        </button>
                                        <button class="btn-icon btn-danger-icon-light size-7"
                                            @click="deleteModal(index)">
                                            <i class="ri-delete-bin-line text-danger text-[13px]"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>

                <div class="overflow-x-auto scrollbar-table px-1.5 py-4">
                    <table class="table-auto w-full ">
                        <tbody>
                            <tr>
                                <td class="dark:text-white"><b>Washing</b></td>
                                <td class="dark:text-white"><b>Qty :  <input type="text" class="form-input text-center"  ref="washing_qty"  v-model="washing.qty"  @input="getWashingTotal()"  @keyup.enter="focusNext('washing_rate')"  ></b></td>
                                <td class="dark:text-white"><b>Rate :  <input type="text" class="form-input text-center" ref="washing_rate"  v-model="washing.rate" @input="getWashingTotal()"  @keyup.enter="focusNext('washing_total')"  ></b></td>
                                <td class="dark:text-white"><b>Total :  <input type="text" class="form-input text-center"  ref="washing_total"  v-model="washing.total"  @keyup.enter="focusNext('discountInput')"  ></b></td>
                                
                                
                            </tr>
                            <tr>
                                <td class="dark:text-white">Total Amount</td>
                                <td class="dark:text-white">Total Payable</td>
                                <td class="dark:text-white">Quantity</td>
                                <td class="dark:text-white">GST</td>
                                <td class="dark:text-white">Discount</td>
                                <td class="dark:text-white">Advance</td>
                                <td class="dark:text-white">Remark</td>
                            </tr>
                            <tr>
                                <td class="dark:text-white"><b>{{account.total}}</b></td>
                                <td class="dark:text-white"><b>{{account.total_payable}}</b></td>
                                <td class="dark:text-white"><b>{{account.qty}}</b></td>
                                <td class="dark:text-white"><b>{{account.gst}}</b></td>
                                <td class="dark:text-white prd_val_col"><input type="text"
                                        class="form-input text-center" @input="getFinalTotal()" ref="discountInput"
                                        v-on:keyup.enter="focusNext('paid')" v-model="account.discount"></td>
                                <td class="dark:text-white prd_val_col"><input type="text" ref="paid"
                                        class="form-input text-center" v-on:keyup.enter="focusNext('remark')"
                                        @input="getFinalTotalAtPaid()" @focus="$event.target.select()" v-model="account.paid"></td>
                                <td class="dark:text-white prd_name_col"><input type="text" ref="remark"
                                        class="form-input " v-on:keyup.enter="stitch_type_for==1?focusNext('delivery'):focusNext('save_btn');"
                                        v-model="account.remark"></td>
                            </tr>
                        </tbody>
                    </table>

                </div>
                 <div>
                    <label class="dark:text-white">Trial Date : <input class="dark:text-dark" type="date" ref="trial_date" v-on:keyup.enter="focusNext('washing')"
                            v-model="sale.trial_date"></label>
                            
                             <label class="dark:text-white">Delivery Date : <input class="dark:text-dark" type="date" ref="delivery" v-on:keyup.enter="focusNext('washing')"
                            v-model="sale.delivery"></label>
                             <!--<label class="dark:text-white">Washing : -->
                             <!--<select class="form-control"  ref="washing"  v-model="sale.washing" @change="focusNext('save_btn')">-->
                             <!--    <option value="YES">YES</option>-->
                             <!--    <option value="NO">NO</option>-->
                             <!--</select>-->
                                 
                             <!--</label>-->
                </div> 
                <div>
                    <h5 v-if="account.due>0" class="text-danger">Due Amount : {{account.due}}</h5>
                </div>
                <div class="flex mt-7">
                    <button @click="save_bill" ref="save_btn"
                        class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">(F2)  Save </button> <span class="text-danger mt-2 ml-2"></span>&nbsp; &nbsp;
                    <button @click="print_invoice" v-show="saleid" 
                        class="btn b-solid btn-danger-solid cursor-pointer shadow-sm">Print</button> &nbsp; &nbsp;
                    <button @click="new_bill" v-show="saleid" 
                        class="btn b-solid btn-danger-solid cursor-pointer shadow-sm">New Bill</button>
                </div>
            </div>


            <!-- End All Language List Table -->
        </div>
    </div>
    <!-- End Main Content -->

    <!-- Start Edit Modal -->
    <div id="editModal" tabindex="-1"
        class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
        style="    background: #00000052;">
        <div class="p-4 w-full max-w-lg max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal"
                    class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>

                <div class="p-4 md:p-5">
                    <form>
                        <div class="mt-5" v-on:keyup.enter="nextFocus">
                            <div class="mt-5">
                                <label for="tagname" class="form-label">Customer Name *</label>
                                <input type="text" v-model="Customer.name" class="form-input" id="first_input"
                                    placeholder="Type Here..." autocomplete="off" required>
                            </div>
                            <div class="mt-5">
                                <label for="tagname" class="form-label">Customer Contact *</label>
                                <input type="text" v-model="Customer.cell" class="form-input" placeholder="Type Here..."
                                    autocomplete="off" required>
                            </div>
                            <div class="mt-5">
                                <label for="tagname" class="form-label">Customer DOB *</label>
                                <input type="date" v-model="Customer.dob" class="form-input" placeholder="Type Here..."
                                    autocomplete="off" required>
                            </div>
                            <div class="mt-5">
                                <label for="tagname" class="form-label">Customer Address *</label>
                                <input type="text" v-model="Customer.address" class="form-input"
                                    placeholder="Type Here..." autocomplete="off" required>
                            </div>
                        </div>
                    </form>

                    <div class="flex justify-end mt-5">
                        <button @click="save" id="saveBtn"
                            class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Edit Modal -->

    <!-- Start Delete Modal -->
    <div id="deleteModal" tabindex="-1"
        class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
        style="    background: #00000052;">
        <div class="p-4 w-full max-w-md max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal"
                    class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
                <div class="p-4 md:p-5 text-center">
                    <img src="assets/images/icons/delete-record.png" alt="delete" class="block h-12 mx-auto">
                    <div class="mt-5 text-center">
                        <h5 class="mb-1">Are you sure?</h5>
                        <p class="text-slate-500 dark:text-zink-200">Are you certain you want to delete this record?</p>
                        <div class="flex justify-center gap-2 mt-6">
                            <button type="reset" @click="closeModal"
                                class="btn b-light btn-danger-light btn-sm">Cancel</button>
                            <button type="submit" @click="remove_item()"
                                class="btn b-solid btn-danger-solid btn-sm">Yes, Delete It!</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>



    <!-- Start Delete Modal -->
    <div id="tagModal" tabindex="-1"
        class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
        style="    background: #00000052;">
        <div class="p-4 w-full max-w-md max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal"
                    class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
                <div class="p-4 md:p-5  ">

                    <div class="mt-5">
                        <h5 class="mb-1 text-center">Add Important Note </h5>

                        <div class="col-span-full lg:col-span-4 leading-none">
                            <label for="" class="form-label">Delivery Date</label>
                            <input type="date" id="delv_on" v-model="selectedProduct.delv_on" placeholder="Type Here"
                                class="form-input" required autocomplete="off">
                        </div>
                        <div class="col-span-full lg:col-span-4 mt-2 leading-none">
                            <label for="" class="form-label">Note</label>
                            <input type="text" id="note" v-model="selectedProduct.note" placeholder="Type Here"
                                class="form-input" required autocomplete="off">
                        </div>


                         <div class="flex justify-end">
                          <button type="button" @click="closeModal"
                       class="btn b-solid btn-primary-solid cursor-pointer shadow-sm mt-2 ml-2">
                       Save
                    </button>
                  </div>



                    </div>
                </div>
            </div>
        </div>
    </div>


    <!-- start plus Model -->


    <!-- Start Delete Modal -->
    <div id="plusModal" tabindex="-1"
        class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
        style="    background: #00000052;">
        <div class="relative m-4 p-4 w-2/5 min-w-[40%] max-w-[40%] rounded-lg bg-white shadow-sm">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal"
                    class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
                <div class="p-4 md:p-5  measurement_bg_card">

                    <div class="mt-2">
                        <h5 class="mb-1 text-center text-danger">Add Measurement</h5>   
                        <div class="mt-2" v-if="already_selected_measurement_label">
                            Selected Measurement For :{{already_selected_measurement_label}}
                        </div>
                         <div class="mt-2" v-else> 
                            <label for="stitchingmeasurement" class="form-label">Stitching Measurement</label> <br>
                            <select class="form-select " id="stitchingmeasurement" style="width:100%"
                                ref="stitchingmeasurement" v-model="sm.stitchingid">
                                <option value=""></option>
                                <option v-for="(item, index) in filteredMeasurements" :key="index" :value="item.id">{{
                                    item.name }}</option>
                            </select>
                        </div>
                        <div v-if="loading_stich_labels">{{loading_stich_labels}}</div>

                        <!-- <div v-for="(item, index) in stichlabels" :key="item.id">
                        <h1>{{ item.lable }}</h1>
                        <input type="text" v-model="lablevalue[index]" placeholder="Type Here"
                                class="form-input" required>
                      </div> -->
                    <div style="display: flex; flex-wrap: wrap; gap: 10px;" id="measurement_inputs">
                        
                        <div v-if="stichlabels && stichlabels.length>0">
                    <div v-if="stichlabels[0].stitch_type==1">
                             <div>
                                    <input
                                    type="text"
                                    v-model="stichlabels[0].lablevalue"
                                    placeholder="Type Here"
                                    class="form-input"
                                    required
                                    style="width: 55px; margin-top: 5px;"
                                    @input="handleInputChange(0, stichlabels[0])"
                                    @keydown.enter="focusNextIp(0)"
                                    @focus="selectText($event)"
                                    :ref="'input0'"
                                    />
                                    
                                </div>
                                <!--3-->
                                 <div style="display: flex;">
                                    <input
                                    type="text"
                                    v-model="stichlabels[1].lablevalue"
                                    placeholder="Type Here"
                                    class="form-input"
                                    required
                                    style="width: 55px; margin-top: 5px;"
                                    @input="handleInputChange(1, stichlabels[1])"
                                    @keydown.enter="focusNextIp(1)"
                                    @focus="selectText($event)"
                                    :ref="'input1'"
                                    />
                                    <input
                                    type="text"
                                    v-model="stichlabels[2].lablevalue"
                                    placeholder="Type Here"
                                    class="form-input"
                                    required
                                    style="width: 55px; margin-top: 5px;"
                                    @input="handleInputChange(2, stichlabels[2])"
                                    @keydown.enter="focusNextIp(2)"
                                    @focus="selectText($event)"
                                    :ref="'input2'"
                                    />
                                    <input
                                    type="text"
                                    v-model="stichlabels[3].lablevalue"
                                    placeholder="Type Here"
                                    class="form-input"
                                    required
                                    style="width: 55px; margin-top: 5px;"
                                    @input="handleInputChange(3, stichlabels[3])"
                                    @keydown.enter="focusNextIp(3)"
                                    @focus="selectText($event)"
                                    :ref="'input3'"
                                    />
                                    
                                </div>
                                
                                <!--3-->
                                 <div  style="display: flex;">
                                    <input
                                    type="text"
                                    v-model="stichlabels[4].lablevalue"
                                    placeholder="Type Here"
                                    class="form-input"
                                    required
                                    style="width: 55px; margin-top: 5px;"
                                    @input="handleInputChange(4, stichlabels[4])"
                                    @keydown.enter="focusNextIp(4)"
                                     @focus="selectText($event)"
                                   :ref="'input4'"
                                    />
                                    <input
                                    type="text"
                                    v-model="stichlabels[5].lablevalue"
                                    placeholder="Type Here"
                                    class="form-input"
                                    required
                                    style="width: 55px; margin-top: 5px;"
                                    @input="handleInputChange(5, stichlabels[5])"
                                    @keydown.enter="focusNextIp(5)"
                                    @focus="selectText($event)"
                                    :ref="'input5'"
                                    />
                                    <input
                                    type="text"
                                    v-model="stichlabels[6].lablevalue"
                                    placeholder="Type Here"
                                    class="form-input"
                                    required
                                    style="width: 55px; margin-top: 5px;"
                                    @input="handleInputChange(6, stichlabels[6])"
                                    @keydown.enter="focusNextIp(6)"
                                    @focus="selectText($event)"
                                    :ref="'input6'"
                                    />
                                    
                                </div>
                                <!--1-->
                                 <div >
                                    <input
                                    type="text"
                                    v-model="stichlabels[7].lablevalue"
                                    placeholder="Type Here"
                                    class="form-input"
                                    required
                                    style="width: 55px; margin-top: 5px;"
                                    @input="handleInputChange(7, stichlabels[7])"
                                    @keydown.enter="focusNextIp(7)"
                                    @focus="selectText($event)"
                                    :ref="'input7'"
                                    />
                                    
                                </div>
                                
                                <!--4-->
                                
                                 <div  style="display: flex;">
                                    <input
                                    type="text"
                                    v-model="stichlabels[8].lablevalue"
                                    placeholder="Type Here"
                                    class="form-input"
                                    required
                                    style="width: 55px; margin-top: 5px;"
                                    @input="handleInputChange(8, stichlabels[8])"
                                    @keydown.enter="focusNextIp(8)"
                                    @focus="selectText($event)"
                                    :ref="'input8'"
                                    />
                                    <input
                                    type="text"
                                    v-model="stichlabels[9].lablevalue"
                                    placeholder="Type Here"
                                    class="form-input"
                                    required
                                    style="width: 55px; margin-top: 5px;"
                                    @input="handleInputChange(9, stichlabels[9])"
                                    @keydown.enter="focusNextIp(9)"
                                    @focus="selectText($event)"
                                    :ref="'input9'"
                                    />
                                    <input
                                    type="text"
                                    v-model="stichlabels[10].lablevalue"
                                    placeholder="Type Here"
                                    class="form-input"
                                    required
                                    style="width: 55px; margin-top: 5px;"
                                    @input="handleInputChange(10, stichlabels[10])"
                                    @keydown.enter="focusNextIp(10)"
                                    @focus="selectText($event)"
                                    :ref="'input10'"
                                    />
                                    <input
                                    type="text"
                                    v-model="stichlabels[11].lablevalue"
                                    placeholder="Type Here"
                                    class="form-input"
                                    required
                                    style="width: 55px; margin-top: 5px;"
                                    @input="handleInputChange(11, stichlabels[11])"
                                    @keydown.enter="focusNextIp(11)"
                                    @focus="selectText($event)"
                                    :ref="'input11'"
                                    />
                                    
                                </div>
                                
                                 <div >
                                    <input
                                    type="text"
                                    v-model="stichlabels[12].lablevalue"
                                    placeholder="Type Here"
                                    class="form-input"
                                    required
                                    style="width: 55px; margin-top: 5px;"
                                    @input="handleInputChange(12, stichlabels[12])"
                                    @keydown.enter="focusNextIp(12)"
                                    @focus="selectText($event)"
                                    :ref="'input12'"
                                    />
                                    
                                </div>
                                
                                 <div >
                                    <input
                                    type="text"
                                    v-model="stichlabels[13].lablevalue"
                                    placeholder="Type Here"
                                    class="form-input"
                                    required
                                    style="width: 55px; margin-top: 5px;"
                                    @input="handleInputChange(13, stichlabels[13])"
                                    @keydown.enter="focusNextIp(13)"
                                    @focus="selectText($event)"
                                    :ref="'input13' "
                                    />
                                    
                                </div>

                     

                                
                        </div>


                    <div v-else> 

                                 <div>
                                    <input
                                    type="text"
                                    v-model="stichlabels[0].lablevalue"
                                    placeholder="Type Here"
                                    class="form-input"
                                    required
                                    style="width: 55px; margin-top: 5px;"
                                    @input="handleInputChange(0, stichlabels[0])"
                                    @keydown.enter="focusNextIp(0)"
                                    @focus="selectText($event)"
                                    :ref="'input0'"
                                    />
                                    
                                </div>
                                     <div>
                                        <input
                                        type="text"
                                        v-model="stichlabels[1].lablevalue"
                                        placeholder="Type Here"
                                        class="form-input"
                                        required
                                        style="width: 55px; margin-top: 5px;"
                                        @input="handleInputChange(1, stichlabels[1])"
                                        @keydown.enter="focusNextIp(1)"
                                        @focus="selectText($event)"
                                        :ref="'input1'"
                                        />
                                        
                                    </div>
                                     <div>
                                        <input
                                        type="text"
                                        v-model="stichlabels[2].lablevalue"
                                        placeholder="Type Here"
                                        class="form-input"
                                        required
                                        style="width: 55px; margin-top: 5px;"
                                        @input="handleInputChange(2, stichlabels[2])"
                                        @keydown.enter="focusNextIp(2)"
                                        @focus="selectText($event)"
                                        :ref="'input2'"
                                        />
                                        
                                    </div>
                                         <div>
                                            <input
                                            type="text"
                                            v-model="stichlabels[3].lablevalue"
                                            placeholder="Type Here"
                                            class="form-input"
                                            required
                                            style="width: 55px; margin-top: 5px;"
                                            @input="handleInputChange(3, stichlabels[3])"
                                            @keydown.enter="focusNextIp(3)"
                                            @focus="selectText($event)"
                                            :ref="'input3'"
                                            />
                                            
                                        </div>
                                          
                               
                                
                                      <!--3-->
                                    <div  style="display: flex;">
                                            <input
                                            type="text"
                                            v-model="stichlabels[4].lablevalue"
                                            placeholder="Type Here"
                                            class="form-input"
                                            required
                                            style="width: 55px; margin-top: 5px;"
                                            @input="handleInputChange(4, stichlabels[4])"
                                            @keydown.enter="focusNextIp(4)"
                                            @focus="selectText($event)"
                                        :ref="'input4'"
                                            />
                                            <input
                                            type="text"
                                            v-model="stichlabels[5].lablevalue"
                                            placeholder="Type Here"
                                            class="form-input"
                                            required
                                            style="width: 55px; margin-top: 5px;"
                                            @input="handleInputChange(5, stichlabels[5])"
                                            @keydown.enter="focusNextIp(5)"
                                            @focus="selectText($event)"
                                            :ref="'input5'"
                                            /> 
                                        
                                    </div>

                                        <div>
                                            <input
                                            type="text"
                                            v-model="stichlabels[6].lablevalue"
                                            placeholder="Type Here"
                                            class="form-input"
                                            required
                                            style="width: 55px; margin-top: 5px;"
                                            @input="handleInputChange(6, stichlabels[6])"
                                            @keydown.enter="focusNextIp(6)"
                                            @focus="selectText($event)"
                                            :ref="'input6'"
                                            />
                                            
                                        </div>

                                           <div>
                                            <input
                                            type="text"
                                            v-model="stichlabels[7].lablevalue"
                                            placeholder="Type Here"
                                            class="form-input"
                                            required
                                            style="width: 55px; margin-top: 5px;"
                                            @input="handleInputChange(7, stichlabels[7])"
                                            @keydown.enter="focusNextIp(7)"
                                            @focus="selectText($event)"
                                            :ref="'input7'"
                                            />
                                            
                                        </div>
                           


                    </div>

                               
                                
                                
                        </div>
                        
                            <!--<template-->
                            <!--    v-for="(item, index) in stichlabels"-->
                            <!--    :key="item.id"-->
                            <!--    class="form-group"-->
                            <!--    :style="getItemStyle(index)" >-->
                            <!--     <div>-->
                            <!--        <input-->
                            <!--        type="text"-->
                            <!--        v-model="item.lablevalue"-->
                            <!--        placeholder="Type Here"-->
                            <!--        class="form-input"-->
                            <!--        required-->
                            <!--        style="width: 55px; margin-top: 5px;"-->
                            <!--        @input="handleInputChange(index, item)"-->
                            <!--        @keydown.enter="focusNextIp(index)"-->
                            <!--         @focus="selectText($event)"-->
                            <!--       :ref="'input' + index"-->
                            <!--        />-->
                            <!--    </div>-->
                            <!--</template>-->
                    </div>


                          <div class="mt-2">
                                 <button type="button" @click="showstylemodal()" ref="style_btn"
                                 class="btn b-solid btn-primary-solid cursor-pointer shadow-sm mt-2 ml-2">
                                 Style
                    </button>
                        </div>


                        <div class="mt-2">
                            <label for="" class="form-label">Note</label>
                            <input type="text" ref="delv_on_note" id="delv_on_note" v-model="selectedProduct.measurementnote"
                                placeholder="Type Here" class="form-input" required autocomplete="off">
                        </div>

                          <div class="mt-2">
                            <label for="" class="form-label">Delivery Date</label>
                            <input type="date" id="delv_on" v-model="selectedProduct.deliverydate" ref="deliverydate"  v-on:keyup.enter="saveSelections"
                                placeholder="Type Here" class="form-input" required autocomplete="off">
                        </div>




                        <div class="flex justify-end">
                             <button @click="reset_measurement" v-if="already_selected_measurement_label" id="saveBtn"
                                class="btn b-solid btn-danger-solid cursor-pointer shadow-sm mt-2">Reset</button>

                             
                            <button @click="save_measurement" id="saveBtn"  v-on:keyup.enter="save_measurement" ref="save_measurement_button"
                                class="btn b-solid btn-primary-solid cursor-pointer shadow-sm mt-2 ml-2"  >Save</button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>










    <!-- end plus Model -->

    <!-- Start Delete Modal -->




<!-- Start Style Modal -->
<div id="showstylemodal" tabindex="-1"  
    class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
    style="background: #00000052;z-index: 999999999;" @keydown.enter.prevent="handleEnterKey">
    <div class="relative m-4 p-4 w-2/5 min-w-[40%] max-w-[40%] rounded-lg bg-white shadow-sm">
        <div class="relative bg-white dark:bg-gray-800 rounded-lg shadow-lg overflow-hidden">
            <button type="button" @click="closeStyleModal"
                class="absolute top-3 end-2.5 text-gray-500 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full p-1.5">
                <i class="ri-close-line text-xl"></i>
            </button>
  
            <div v-if="current_selected_stitch_type==1">        
            <div class="p-5 max-h-[75vh] overflow-y-auto">
               <h5>Shirt Style</h5>
                <div class=" text-sm text-gray-800 dark:text-gray-200">

                    <table class="table">
                        <thead>
                            <tr>
                                <th>Sr</th>
                                <th>Style</th>
                                <th>Sub Style</th>
                              
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in measurement_styel_Array" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ item.mainPoint }}</td>
                                <td>
                                    <ul style="" ref="style_open" tabindex="0" class="measurements_style_lable">
                                        <li v-for="(subPoint, subIndex) in item.subPoints" :key="subIndex" for="">
                                              <label class="cursor-pointer select-none">
                                            <input type="checkbox" :value="subPoint"  :checked="isChecked(item.mainPoint, subPoint)"
                                                                @change="toggleSelection(item.mainPoint, subPoint)" :data-main-point="item.mainPoint" :data-sub-point="subPoint" 
                                                        /> {{ subPoint }}</label>
                                        </li>
                                    </ul>
                                </td>
                               
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="text-sm text-danger  dark:text-gray-300">
                                {{ selectedProduct.measurementnote }}
                            </div>
            </div>
            </div>

            <div v-else>
                    <div class="p-5 max-h-[75vh] overflow-y-auto">
                <h5>Pant Style</h5>
                <div class=" text-sm text-gray-800 dark:text-gray-200">

                    <table class="table">
                        <thead>
                            <tr>
                                <th>Sr</th>
                                <th>Style</th>
                                <th>Sub Style</th>
                              
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in measurement_styel_Array_pant" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ item.mainPoint }}</td>
                                <td>
                                    <ul style="" ref="style_open" tabindex="0"  class="measurements_style_lable">
                                        <li v-for="(subPoint, subIndex) in item.subPoints" :key="subIndex" for="">
                                              <label class="cursor-pointer select-none">
                                            <input type="checkbox" :value="subPoint"  :checked="isCheckedForPant(item.mainPoint, subPoint)"
                                                                @change="toggleSelectionPant(item.mainPoint, subPoint)" :data-main-point="item.mainPoint" :data-sub-point="subPoint" 
                                                        /> {{ subPoint }}</label>
                                        </li>
                                    </ul>
                                </td>
                               
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="text-sm text-danger  dark:text-gray-300">
                                {{ selectedProduct.measurementnote }}
                            </div>
            </div>
            </div>

            <div class="flex justify-end space-x-3 mt-6 pt-4 border-t border-gray-200 dark:border-gray-700">

                           
<br>
                <button type="button" @click="saveSelections"   @keyup.enter="focusDeliveryDate"
                    class="px-4 py-2 btn b-solid btn-primary-solid cursor-pointer shadow-sm mt-2 ml-2" ref="save_style_btn">
                    Save Changes
                </button>
            </div>
        </div>
    </div>
</div>

<!-- End Style Modal -->


<!-- sart modal ---------------------------------------------------------------------------------------------------------------------------------------------->

        <!-- Modal Wrapper -->
                    <div id="showratetypemodal" 
                        v-if="showratetypemodal"  style="background: #00112069;"
                        tabindex="-1"
                        class="fixed inset-0 z-[999999999] flex items-center justify-center bg-black/30"
                        >

                        <!-- Modal Container -->
                        <div class="bg-white dark:bg-gray-800 rounded-lg shadow-[0_10px_40px_rgba(0,0,0,0.6)] w-2/5 min-w-[40%] max-w-[40%] p-6 relative border-2 border-black">

                            <!-- Close (Cancel) Button -->
                            <button @click="closeModal" type="button"
                                    class="absolute top-4 right-4 text-gray-500 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full p-1.5">
                                <i class="ri-close-line text-xl"></i>
                            </button>

                            <!-- Modal Title -->
                            <h3 class="text-lg font-semibold mb-6">Select Salesperson</h3>

                            <!-- Rate Buttons -->
                            <label>Select Salesperson</label>
                             <select class="form-input mb-6" id="employee_name" ref="employee_name"
                                    v-model="sale.selected_employeeid" autofocus>
                                    <option v-for="(item ,index)  in all_employees" :value="item.id">{{item?.empname}}</option>
                                </select>
                                <br>
                            <div class="grid grid-cols-2 gap-4 mt-6">
                                <button type="button" 
                                        @click="setratetype(1)" 
                                        class="btn btn-primary-solid px-4 py-2 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-600 focus:bg-blue-100 modal_btn" 
                                        ref="stichRateBtn">
                                    Stiching Sale
                                </button>

                                <button type="button" 
                                        @click="setratetype(2)" 
                                        class="btn btn-secondary-solid px-4 py-2 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-600 focus:bg-blue-100 modal_btn" 
                                        ref="saleRateBtn">
                                    Regular Sale
                                </button>
                            </div>

                        </div>
                    </div>









<!-- end modal------------------------------------------------------------------------------------------------------------------------------------------------>


































    <!-- End Delete Modal -->
</template>
<style scoped>
.modal_btn:focus{
    border:1px solid red;
}
 
.measurements_style_lable{
    display: ruby-text;
}
.measurements_style_lable label{
    margin-right: 10px;
    padding: 5px;
}
.measurements_style_lable label:hover{
    background: aquamarine;
}
    .form-input {
        height: 20px;
        padding: 15px 2px;
        border: 1px solid black;
        color: black;

    }

    thead tr {
        background: #95d2ff3b;
    }

    .select2.select2-container .select2-selection {
        height: 25px;
    }

    .select2-selection__arrow {
        display: none;
    }

    .prd_name_col {
        width: 350px;
    }

    .prd_val_col {
        width: 80px;
    }

    .prd_val_col_x {
        width: 180px;
        text-align: center;
        background: #696900;
        color: white;
    }

    .prd_barcode_col {
        width: 150px;
    }

    .entry_row {
        background: yellow;
    }

    .select2-container {
        width: 100% !important;
    }

    td {
        /*color: black;*/
    }

    .right {
        text-align: right;
    }

    select {
        padding: 0px 0px !important;
        height: 30px !important;
    }

    .form-input:focus {
        background: yellow;
    }

    .dark .form-input:focus {
        background: white;
        color: black;
    }

    .dark .form-input {
        height: 20px;
        padding: 15px 2px;
        border: 1px solid black;
        color: black;
        background: white;

    }

    .dark .select2 {
        height: 20px;
        padding: 15px 2px;
        border: 1px solid black;
        color: black;
        background: white;

    }

    

        /* element.style {
        background: #040300cc;
    } */

</style>

<script>
    // @ is an alias to /src
    // import HelloWorld from '@/components/HelloWorld.vue'
    import axios from 'axios';

    export default {
        name: 'SaleView',
        components: {

        },
        mounted() {
                window.addEventListener('keydown', this.handleArrowKeys);
             
                if(this.$route.query.id){
                     this.getBasics(this.$route.query.id);

                }else{
                    this.getBasics();

                }
              

               this.showratetypemodal=true;
               
               
            //   setTimeout(() => { this.$refs.saleRateBtn.focus(); }, 200);

                // if (this.stitch_type_for == 1) {
                //     this.account.paid = this.account.total_payable;
                // }

        }, 
        
            beforeUnmount() {
              window.removeEventListener('keydown', this.handleArrowKeys);
            },
        
        data() {
            return {

                invoice:{
                    invoice_no:0,
                },
                

                get_sale_details:[],
                edit_sale_id:'',



                washing:{qty:0,rate:20,total:0},
                mainPointFor: '',
                subPointfor:'',

                temp_shirt:[],

                stitch_type_for:0,
                for_model_open:0,



                temp_pant:[],
                currentFocusedIndex: -1,
                selectedCheckboxes:[],
                selectedSubPoints: new Set(),
                selectedSubPointsPants: new Set(),
                isSet: 0,
                isAdd: 0,
                isEdit: 0,
                saleid: 0,
                isDelete: 0,
                deleteId: 0,
                productsList: [],
                customerList: [],
                filtermeasure: [],
                selectedProduct: [],
                sale_product_list: [],
                All_stiching_lables: [],
                showmodel: false,
                showratetypemodal:false,
                custid: '',

                Customer: { name: '', cell: '', address: '', dob: '' },
                prd: {},
                sale: { custcell: '', custgst: '', custaddress: '', custid: '', date: this.todayDate() ,selected_employeeid:0},
                account: { total: 0, qty: 0, gst: 0, paid: 0, total_payable: 0, discount: 0, remark: '' },
                prd_select_tag: null,
                employees: { empname: '', emprole: '0', isMainAdmin: 0 },
                all_employees:[],
                tag_prd_id: 0,
                cur_remove_row_index: 0,
                product_cat: [],
                qty_mtr: 0,
                qty_unit: 0,
                stitchid: null,

                calculatemsur: [],
                stiching_mesurements: [],
                filteredMeasurements: [],
                stichlabels: [],
                seletestetchid: '',

                sm: {
                    lablevalue: [],
                    stitchingid: '',
                    stitching_label: '',
                    lableid: [],
                    lable: [],

                },
                current_index_of_added_product: 0,
                selected_stitch_id: 0,
                loading_stich_labels: '',
                already_selected_measurement_label:'',
             
selections: {
      collar: [],
      silai: [],
      pocket: [],
      shoulder: [],
      front: [],
      cuff: []
    },
    current_selected_stitch_type:0,
    measurement_styel_Array: [
                        {
                            mainPoint: "शर्ट",
                            subPoints: [
                                "बु शर्ट",
                                "ॲपल कट जास्त",
                                "ॲपल कट",
                                "बु शर्ट / चॉक कट"
                            ],
                            status: "सक्रिय"
                        },
                        {
                            mainPoint: "कॉलर",
                            subPoints: [
                                "पॉईंटेड",
                                "कट वे",
                                "बटण डाउन",
                                "बॅण्ड  पट्टी",
                            ],
                            status: "प्रगतीत"
                        },
                        {
                            mainPoint: "शिलाई",
                            subPoints: [
                                "दाब",
                                "डबल",
                                "ट्रिपल",
                                "प्लेन",
                                "अर्घा दाब"
                            ],
                            status: "पूर्ण"
                        },
                        {
                            mainPoint: "पाकीट",
                            subPoints: [
                                "पेन",
                                "फ्लॅप",
                                "2",
                                "आतुन",
                                "नको"
                            ],
                            status: "प्रलंबित"
                        },
                        {
                            mainPoint: "फॅशन पट्टी",
                            subPoints: [
                                "फोल्ड",
                                "प्लेन",
                                "बटन डाऊन",
                                // "पेन पाकीट",
                                // "प्लेन फॅशन पट्टी"
                            ],
                            status: "प्रलंबित"
                        },
                         {
                            mainPoint: "शोल्डर",
                            subPoints: [
                                "V",
                            ],
                            status: "प्रलंबित"
                        },
                         {
                            mainPoint: "कप",
                            subPoints: [
                                "2 इच",
                                "2 || इच",
                                "2 ||| इच",
                                "3 इच",
                                "साइड कव्हर",
                                "साइड शिलाई",
                               // "2 || इच "
                            ],
                            status: "प्रलंबित"
                        },
                        // {
                        //     mainPoint: "--",
                        //     subPoints: [
                        //         "साइड",
                        //         "कव्हर",
                        //         "साइड शिलाइ",
                        //     ],
                        //     status: "प्रलंबित"
                        // },
                         {
                            mainPoint: "टिप",
                            subPoints: [
                                "मेडियम फिटींग",
                                "फिटिंग",
                                "लुजिंग",
                            
                            ],
                            status: "प्रलंबित"
                        },
                         {
                            mainPoint: "अतिरिक्त स्टाईल",
                            subPoints: [
                                "नको",
                                "हवा आहे",
                            ],
                            status: "प्रलंबित"
                        },
                         {
                            "mainPoint": "शर्टचे प्रकार",
                            "subPoints": [
                                "अर्ध बाह्यांचा शर्ट",
                                "पूर्ण बाह्यांचा शर्ट"
                            ],
                            "status": "प्रलंबित"
                        }
                    ],



 measurement_styel_Array_pant: [
                        {
                            mainPoint: "प्लेट",
                            subPoints: [
                                "बिगर",
                                "2",
                                "1",
                                "3",
                            ],
                            status: "सक्रिय"
                        },
                        {
                            mainPoint: "पाकीट",
                            subPoints: [
                                "साइड",
                                "क्रॉस",
                                "फ्रंट",
                                "मोबाइल",
                                "पेन",
                            ],
                            status: "प्रगतीत"
                        },
                        {
                            mainPoint: "शिबँक पाकीटलाई",
                            subPoints: [
                                "1",
                                "2",
                                "फ्लॅप",
                                "2 पॅच",
                                "नको"
                            ],
                            status: "पूर्ण"
                        },
                        {
                            mainPoint: "वॉच पाकीट",
                            subPoints: [
                                "1",
                                "2",
                                "मोठा",
                                "नको"
                            ],
                            status: "प्रलंबित"
                        },
                        {
                            mainPoint: "साइड",
                            subPoints: [
                                "चिरवा",
                                "डबल टिप",
                                "किनारी टिप",
                                "दाब टिप",
                            ],
                            status: "प्रलंबित"
                        },
                        //  {
                        //     mainPoint: "शोल्डर",
                        //     subPoints: [
                        //         "1",
                        //     ],
                        //     status: "प्रलंबित"
                        // },
                         {
                            mainPoint: "लुप्स",
                            subPoints: [
                                "मोठा",
                                "रेग्युलर",
                                "फिक्स",
                                "3 मोटे",
                            ],
                            status: "प्रलंबित"
                        },
                        {
                            mainPoint: "इस्त्री",
                            subPoints: [
                                "उभी",
                                "आडवी",
                            ],
                            status: "प्रलंबित"
                        },
                         {
                            mainPoint: "बॉटम",
                            subPoints: [
                                "फोल्ड",
                                "हात शिलाई",
                                "मशिन शिलाई",
                                "चैन",
                            ],
                            status: "प्रलंबित"
                        },
                         {
                            mainPoint: "टिप",
                            subPoints: [
                                "मेडियम फिट्टींग",
                                "फिट्टींग",
                                "लुजिग",
                            ],
                            status: "प्रलंबित"
                        },
                        {
                            mainPoint: "अतिरिक्त स्टाईल",
                            subPoints: [
                                "नको",
                                "हवा आहे",
                            ],
                            status: "प्रलंबित"
                        },

                         {
                            "mainPoint": "शर्टचे प्रकार",
                            "subPoints": [
                                "अर्ध बाह्यांचा शर्ट",
                                "पूर्ण बाह्यांचा शर्ट"
                            ],
                            "status": "प्रलंबित"
                        }
                    ],













                    
                    isModalOpen:false,
                    isMesaurmentModalOpen:false,
                    isStyleModalOpen:false,
                    isEditMode:false,

            }
        },
        methods: {


                        // handleArrowKey(event) {
                        //         const current = document.activeElement;
                        //         alert(event);

                         

                        //         // Arrow Right
                        //         if (event.key === "ArrowRight") {
                        //             if (current === this.$refs.stichRateBtn) {
                        //                 this.$refs.saleRateBtn.focus();
                        //             } else if (current === this.$refs.saleRateBtn) {
                        //                 this.$refs.stichRateBtn.focus();
                        //             }
                        //         }

                        //         // Arrow Left
                        //         else if (event.key === "ArrowLeft") {
                        //             if (current === this.$refs.saleRateBtn) {
                        //                 this.$refs.saleRateBtn.focus();
                        //             } else if (current === this.$refs.saleRateBtn) {
                        //                 this.$refs.saleRateBtn.focus();
                        //             }
                        //         }

                        //         else if (event.key === "Enter") {
                        //             if (current === this.$refs.stichRateBtn) {
                        //                 this.setratetype(1);
                        //             } else if (current === this.$refs.saleRateBtn) {
                        //                 this.setratetype(2);
                        //             }
                        //         }
                        //     },





     focusQtyUnit() {
            const input = this.$refs.qty_unit;
            input.focus();
            input.select(); // This selects the full text inside the input
            },


           focuslastQtyUnit() {
   // alert("hello");
        const input =this.$refs.qty;
             input.focus();
            input.select();
    },
      focusDeliveryDate() {
    this.$refs.deliverydate.focus();
                 $("#showstylemodal").addClass('hidden');
   
  },
             selectText(event) {
                event.target.select();
              },
            getQtyMtr() {
                // this.prd.qty = (this.prd.qty_mtr || 0) * (this.prd.qty_unit || 0);
                
                    const qty = (this.prd.qty_mtr || 0);
                    const rate = (this.prd.qty_unit || 0);
                
                    const total = qty * rate;
                
                    this.prd.qty = total.toFixed(2);


                
                 this.getTotal(); 
            },
            setItemStichType() {
                var self = this;

                self.stitchid = this.prd.stich_type
                // alert(self.stitchid);
                if (this.prd.stich_type) {
                    this.prd.salerate = this.prd.stich_rate;
                    this.prd.total = this.prd.stich_rate;
                }


                // setTimeout(() => { self.$refs.qty.focus(); }, 200)
            },
           print_invoice(id) {
            // If stichlabels is empty or undefined, go for thermal print
            if ((this.ismeasurement == 0)) {
                window.open('/thermalPrint?q=' + this.saleid, '_blank');
            } else {
                if (this.saleid > 0 && this.setting[0].settingvalue == "Thermal") {
                window.open('/thermalPrint?q=' + this.saleid, '_blank');
                } else {
                window.open('/A4?q=' + this.saleid, '_blank');
                }
            }
            },
           
            new_bill() {
                if (this.saleid > 0)
                  window.location.reload();

            },
            todayDate() {
                const dateObj = new Date();
                var month = dateObj.getMonth() + 1;
                var day = dateObj.getDate();
                const currentDate = dateObj.getFullYear() + "-" + ((month < 10) ? '0' + month : month) + "-" + ((day < 10) ? '0' + day : day);
                return currentDate;
            },
            closeModal() {

                $("#editModal").addClass('hidden');
                $("#deleteModal").addClass('hidden');
                $("#tagModal").addClass('hidden');
                $("#plusModal").addClass('hidden');
                $("#showstylemodal").addClass('hidden');
                $("#showratetypemodal").addClass('hidden');
        

                this.isAdd = 0;
                this.isEdit = 0;
                this.isDelete = 0;
                this.deleteId = 0;
                this.isModalOpen=false;
                this.isStyleModalOpen=false;
                this.isMesaurmentModalOpen=false;
                this.showratetypemodal=false;
            },

   closeStyleModal() {

                $("#showstylemodal").addClass('hidden');
                // this.isMesaurmentModalOpen=true;
                this.isStyleModalOpen=false;
                this.isModalOpen=false;
                this.isMesaurmentModalOpen=false;

                this.isAdd = 0;
                this.isEdit = 0;
                this.isDelete = 0;
                this.deleteId = 0;
            },



            tagModal(index) {
                // this.sale_product_list[index].
                //this.tag_prd_id=index;//this.sale_product_list[index].id;

                this.selectedProduct = this.sale_product_list[index];
                $("#tagModal").removeClass('hidden');
                this.isModalOpen=false;

            },

            plusModal(index, row_item) {
                if(this.stitch_type_for==0)
                    return;
                
                // this.selectedProduct = this.sale_product_list[index];


                // Clear the measurement note
                // this.selectedProduct.measurementnote = "";

                
             var self = this;
                this.current_index_of_added_product = index;
                
                self.current_selected_stitch_type=this.sale_product_list[index].stich_type;
                
                //console.log("Selected Products" + this.sale_product_list.length);

                 // Reset the Select2 dropdown and v-model
                this.sm.stitchingid = ""; // Clear the v-model
                if ($("#stitchingmeasurement").data('select2')) {
                   $('#stitchingmeasurement').select2('destroy');
                //    self.$nextTick(()=>{})
                }

                
                            
                if (this.sale_product_list[this.current_index_of_added_product]?.measurements) {
                    //console.log("Measurement fround for index "+ this.current_index_of_added_product );
                        if (self.sale_product_list[self.current_index_of_added_product]?.measurements) {

                            // console.log('Measurements found:', self.sale_product_list[self.current_index_of_added_product].measurements);

                          

                                var measures_here = self.sale_product_list[self.current_index_of_added_product]?.measurements;
                                  console.log(measures_here);
                               self.already_selected_measurement_label= measures_here?.stitching_label || '';

                               
                          
                            
                                for (let index = 0; index < measures_here.lableid.length; index++) {
                                    const element = measures_here.lableid[index];
                                    // alert(element);

                                    if(self.edit_sale_id > 0){
                            self.stichlabels[index]={
                                            id:element,
                                            lable:measures_here.lable[index],
                                            lablevalue:measures_here.lablevalue[index],
                                            stitch_type:self.sale_product_list[self.current_index_of_added_product].stich_type
                                        };

                                    }else{


                         self.stichlabels[index]={
                                            id:element,
                                            lable:measures_here.label[index],
                                            lablevalue:measures_here.lablevalue[index],
                                            stitch_type:self.sale_product_list[self.current_index_of_added_product].stich_type
                                        };




                                    }

 
                                       
                                       
                                }
                                
                                 this.$nextTick(() => {
                                 self.$refs['input0'].focus();
                                 });
                                //   $("#first_input").focus();

                                console.log(  self.stichlabels);
                            } else {
                                
                            }

                } else {
                    console.error("No Measurement index "+ this.current_index_of_added_product );
                    self.already_selected_measurement_label= "";
                     console.log( self.stiching_mesurements);
                     console.log( row_item.stich_type);
                    var self = this;
                    self.filteredMeasurements = self.stiching_mesurements.filter(item =>
                        item.parentid === row_item.stich_type
                    );
                    console.log( self.filteredMeasurements);
                    self.stichlabels = [];
                    //  $("#stitchingmeasurement").select2("val", "");
                    this.$nextTick(() => {
                     self.init_stitchingmeasurement();
                     // $('#stitchingmeasurement').select2().select2('open');
                    });

                }
            
                
                this.selectedProduct=this.sale_product_list[index];
                console.log("selectedProduct");
                console.log(self.selectedProduct);
               
                $("#plusModal").removeClass('hidden');
                this.isMesaurmentModalOpen=true;
                this.isStyleModalOpen=false;
                
                
                this.selectedSubPointsPants=new Set();
                this.selectedSubPoints=new Set();
                
                
                this.isModalOpen=true;
                //   this.showmodel=true;
                this.$nextTick(() => {
                    // self.init_stitchingmeasurement();
                    
                            $('#stitchingmeasurement').select2().select2('open');
                    });
            },


            addModal() {

                this.Customer = { name: '', cell: '', address: '', gst: '' };

                if (!this.isAdd){
                    $("#editModal").removeClass('hidden');
                    this.isModalOpen=true;
                }
                else{
                    this.isModalOpen=false;
                    $("#editModal").addClass('hidden');
                }

                $("#first_input").focus();
                this.isAdd = !this.isAdd;
            },
            focusNext(ref) {
                this.$refs[ref].focus();
               try { this.$refs[ref].select();} catch (e) { }
            },
            nextFocus(e) {
                try {
                    const inputs = Array.from(e.target.form.querySelectorAll('input'));
                    const index = inputs.indexOf(e.target);

                    if (index < inputs.length) {
                        try {
                            inputs[index + 1].focus();
                            inputs[index + 1].select();
                        } catch (error) {
                            $("#saveBtn").focus();
                        }
                    }
                } catch (e) { }
            },
            editModal(item) {
                if (item) {
                    let copy = JSON.parse(JSON.stringify(item));
                    this.cat = copy;
                }
                if (!this.isEdit){
                   // $('#cust_name').select2('close');
                    $("#editModal").removeClass('hidden');
                    this.isModalOpen=true;
                }
                else{
                    $("#editModal").addClass('hidden');
                    this.isModalOpen=false;
                }
                
                this.isEdit = !this.isEdit;
            },

            deleteModal(id) {
                this.deleteId = id;
                if (!this.isDelete){
                    $("#deleteModal").removeClass('hidden');
                    this.isModalOpen=true;
                }
                else{
                    $("#deleteModal").addClass('hidden');
                    this.isModalOpen=false;
                }
                this.isDelete = !this.isDelete;
            },
            getTotal_added(item) {
                // alert(this.stitch_type_for);
                if(this.stitch_type_for==1){
                 
                     try {
                    //item.total = ((item.qty) ? parseFloat(item.qty) : parseFloat(item.set_qty)) * ((item.stich_rate) ? parseFloat(item.stich_rate) : parseFloat(item.set_rate));// parseFloat(item.salerate);
                    
                    //qty_mtr  17.07.2025
                    // item.total = ((item.qty_mtr) ? parseFloat(item.qty_mtr) : parseFloat(item.set_qty)) * ((item.stich_rate) ? parseFloat(item.stich_rate) : parseFloat(item.set_rate));
                        const qty = parseFloat(item.qty_mtr ?? item.set_qty) || 0;
                        const rate = parseFloat(item.stich_rate ?? item.set_rate) || 0;
                        const total = qty * rate;
                        item.total = total.toFixed(2);
                        // alert(item.total);
                        this.getFinalTotal();
                    } catch (error) {

                }

                }else{

                     try {
                    // item.total = ((item.qty) ? parseFloat(item.qty) : parseFloat(item.set_qty)) * ((item.salerate) ? parseFloat(item.salerate) : parseFloat(item.set_rate)) ;// parseFloat(item.salerate);
                    // item.total=(item.total).toFixed(2);
                    
                        const qty = parseFloat(item.qty ?? item.set_qty) || 0;
                        const rate = parseFloat(item.salerate ?? item.set_rate) || 0;
                        const total = qty * rate;
                        item.total = total.toFixed(2);
                        // alert(item.total);


                    this.getFinalTotal();
                } catch (error) {

                }

                }
               
            },
            getWashingTotal(){
                this.washing.total=parseFloat(this.washing.qty || 0)* parseFloat(this.washing.rate || 0);
                 this.getFinalTotal();
            },
            getFinalTotalAtPaid() {
                try {
                    



                } catch (error) {

                }
            },
            getFinalTotal() {
                try {
                    var total_amt = 0;
                    var total_payable = 0;
                    var total_qty = 0;



                    if (this.stitch_type_for == 1) {

                           this.sale_product_list.forEach(item => {
                                // total_amt += parseFloat(item.qty) * parseFloat(item.stich_rate);;
                                
                                total_amt += parseFloat(item.qty_mtr) * parseFloat(item.stich_rate);;
                                total_qty += parseFloat(item.qty);
                            });
    
                        }else{

                      this.sale_product_list.forEach(item => {
                        total_amt += parseFloat(item.qty) * parseFloat(item.salerate);;
                        total_qty += parseFloat(item.qty);
                    });
                            
                        }

               

                    this.account.total_payable = total_amt.toFixed(2);
                    this.account.total = total_amt.toFixed(2);
                    this.account.qty = total_qty.toFixed(2);

                     if(this.washing?.total){
                         this.account.total=(parseFloat(this.account.total)+parseFloat(this.washing.total)).toFixed(2);
                        this.account.total_payable=(parseFloat(this.account.total_payable)+parseFloat(this.washing.total)).toFixed(2);//=parseFloat(this.washing.qty || 0)* parseFloat(this.washing.rate || 0);
                    }
                
                    //as per 5%
                    this.account.gst = parseFloat(total_amt * (5 / 100)).toFixed(2);

                    if (this.account.discount){
                        let discount_percent=parseFloat(this.account.total_payable) * (parseFloat(this.account.discount)/100);
                        this.account.total_payable =(parseFloat(this.account.total_payable)-discount_percent).toFixed(2);
                        this.account.paid=this.account.total_payable;
                        // this.account.total_payable = (this.account.total_payable - parseFloat(this.account.discount)).toFixed(2);
                        
                    }
                    
                    // if (this.account.paid)
                    //     this.account.due = (this.account.total_payable - parseFloat(this.account.paid)).toFixed(2);

                             // Optional: Auto-fill paid if it's empty or zero
                    // if (!this.account.paid || this.account.paid == 0) {
                        if (this.stitch_type_for == 1) {
                            this.account.paid = parseFloat(this.account.total_payable * 0.70).toFixed(2); // 70%
                        } else {
                            this.account.paid = parseFloat(this.account.total_payable).toFixed(2); // 100%
                        }
                    // }
                    
                    



                } catch (error) {

                }
            },


            setratetype(_id) {
                if (_id == 1) {
                    this.stitch_type_for = 1;
                 //   alert(this.stitch_type_for);


                       this.showratetypemodal=false;
                       this.for_model_open = 1;

                    if(this.for_model_open ==1){
                          $("#cust_name").select2('open');
                    }
                      
               


                   // alert("stich rate applied");
                } else {
                        this.stitch_type_for = 0;
                        this.showratetypemodal=false;
                        this.for_model_open = 1;

                          if(this.for_model_open ==1){
                              $('#cust_name').val('23').trigger('change');
                            //   $("#cust_name").select2("val", "23");
                            //  $("#cust_name").select2('open');
                    }
                     
                }
            },








            getTotal() {
                // try {
                //     // this.prd.total = parseFloat(this.prd.qty) * parseFloat(this.stitch_type_for==1? this.prd.stich_rate:this.prd.salerate);
                    
                //     //17.07.2025
                //     if(this.stitch_type_for==1)
                //         this.prd.total = parseFloat(this.prd.qty_mtr) * parseFloat(this.stitch_type_for==1? this.prd.stich_rate:this.prd.salerate);
                //     else 
                //         this.prd.total = parseFloat(this.prd.qty) * parseFloat(this.stitch_type_for==1? this.prd.stich_rate:this.prd.salerate);
                //     this.getFinalTotal();
                // } catch (error) {

                // }
                
                //03112025
                try {
                        const isStitch = this.stitch_type_for === 1;
                    
                        const qty = parseFloat(isStitch ? this.prd.qty_mtr : this.prd.qty) || 0;
                        const rate = parseFloat(isStitch ? this.prd.stich_rate : this.prd.salerate) || 0;
                    
                        this.prd.total = (qty * rate).toFixed(2);
                    
                        this.getFinalTotal();
                    } catch (error) {
                        console.error('Error calculating product total:', error);
                    }
                
                
            },
            async getBasics(id) {
                var self = this;
                axios.post('getSalesBasic',{id:id}).then(function (response) {
                    self.productsList = response.data.products;
                    self.customerList = response.data.customers;
                    self.employees = response.data.userDetails;
                    self.all_employees = response.data.all_employees;
                    self.product_cat = response.data.product_cat;
                    self.stiching_mesurements = response.data.stiching_mesurements;
                    self.All_stiching_lables = response.data.All_stiching_lables;
                    self.setting=response.data.setting;

                //    for (let i = 0; i < self.setting.length; i++) {
                      
                    // }

                    self.edit_sale_id=id;

                    if(response.data?.is_edit == 1){
                        
                        self.isEditMode=true;
                        
                        
                        
                        
                        let _customer_details=response.data.customer_details;
                   
                        
                        
                        
                        let _sales_details=response.data.get_sale_details;
                        if(_sales_details.ismeasurement==1){
                                    self.current_selected_stitch_type=1;
                                    self.stitch_type_for = 1;
                        }else {
                                    self.current_selected_stitch_type=1;
                                    self.stitch_type_for = 1;
                        }
                        
                        
                        self.sale={
                               custid: _customer_details.id, 
                               date: _sales_details.salesperson ,
                               selected_employeeid:_sales_details.salesperson ,
                               delivery:_sales_details.salesperson ,
                               trial_date:_sales_details.trial_date ,
                               delivery:_sales_details.delivery ,
                               custcell:_customer_details?.cell ||'',
                               custaddress:_customer_details?.address ||'',
                               dob:_customer_details?.dob ||'',
                              
                               
                        };


                        self.washing={
                            qty: _sales_details.washing_qty,
                            rate: _sales_details.washing_rate,
                            total: _sales_details.washing_total,

                        };


                        
                        
                        
                        let _account_details=response.data.accounting_details;
                        
                        self.account={
                               total: _account_details.total, 
                               total_payable: _account_details.total_payable, 
                               remark: _account_details.note ,
                               discount:_account_details.discount ,
                               paid:_account_details.paid ,
                               gst:_account_details.is_gst , 
                               
                        };
                          $("#showratetypemodal").addClass('hidden');
                          
                          
                          
                          
                        
                        let _stock_details=response.data.get_stock_details;
                        self.sale_product_list = _stock_details.map(row => {
                            // extract measurements safely
                            let m = row.measurements ?? [];
                            let _stitching_label="";
                           
                            try{
                                if(m.length>0)
                                    _stitching_label = m[0]?.stitching_name || "";
                            } catch (error) {}
                            
                            
                            return {
                                id: row.prdid,
                                barcode: row.barcode,
                                prdname: row.prd_name,
                                cat_name: row.cat_name,
                                stich_type: row.stich_type,
                                measurementnote: row.measurementnote,
                                deliverydate: row.deliverydate,
                                
                                stich_rate: row.rate,
                                salerate: row.rate,
                        
                                qty_mtr: row.meterqty,
                                qty_unit: row.pieceqty,
                                qty: Math.abs(row.qty),
                        
                                total: (Number(row.rate) * Math.abs(row.qty)).toFixed(2),
                         
                                measurements: { 
                                    stitching_name: m.map(x => x.stitching_name),
                                    lableid: m.map(x => x.lableid),
                                    lable: m.map(x => x.lableid),
                                    lablevalue: m.map(x => x.lablevalue),
                                    stitchingid: m.length > 0 ? m[0].stitchingid : 0,
                                    parentid: m.length > 0 ? m[0].parentid : row.stich_type,
                                    stitching_label:_stitching_label    
                                },
                                
                            };
                        });
                            
                            
                            
                        
                        // .selected_employeeid=_sales_details.salesperson;
                        
                        
                      
                        // self.account.total = response.data.get_sale_details.total;
                        // self.account.remark = response.data.get_sale_details.remark;
                        // self.account.discount = response.data.get_sale_details.discount;
                        // self.account.paid = response.data.get_sale_details.paid;
                        // self.account.gst = response.data.get_sale_details.gst;
                        // self.sale.delivery = response.data.get_sale_details.delivery;
                        // self.sale.trial_date = response.data.get_sale_details.trial_date;
                        // self.washing.qty = response.data.get_sale_details.washing_qty;
                        // self.washing.rate = response.data.get_sale_details.washing_rate;
                        // self.washing.total = response.data.get_sale_details.washing_total;
                       

                            // self.sale_product_list.forEach((item, index) => {
                            //     item.qty = self.response.data.get_stock_details[index]?.qty || 0;
                            // });

                       

                       

                     

                    }else {
                        //    if (self.setting.length >= 6) {
                            self.invoice.invoice_no =response.data.inv_number;
                            // break;
                        //  }
                     $("#showratetypemodal").removeClass('hidden');
                    }


                    
                
              
                

                }).then(() => {
                    var self = this;



                  //  self.showratetypemodal=true;

                    self.prd_select_tag = $("#prd_name").select2({
                        width: '100%',
                        dropdownAutoWidth: true,
                        placeholder: "Search Product Here...",
                        "language": {
                            "noResults": function () {
                                return "No Results Found <a ref='add_product' class='  btn-primary-icon-light size-7'>Add Product</a>";
                            }
                        },
                        escapeMarkup: function (markup) {
                            return markup;
                        }
                    }).on('change', function (event) {
                        self.selectedProduct = self.productsList.find(item => item.id === event.target.value);
                        
                        self.prd = { ...self.selectedProduct };
                        self.prd.prdname = self.selectedProduct.name;
                        
                        // self.prd.alises=self.prd.cat_name;
                        // //console.log(self.prd );
                        
                        if (self.isSet == 1) {
                            self.prd.qty = self.selectedProduct.set_qty;
                            self.prd.salerate = self.selectedProduct.set_rate;
                        } else
                            self.prd.qty = 1;

                        self.getTotal();
                        //setTimeout(() => { self.$refs.qty_mtr.focus();}, 300)
                        setTimeout(() => {
                        const input = self.$refs.qty_mtr;
                        input.focus();
                        input.select();
                        }, 300);
                        // self.$refs.qty.focus();

                        // if (self.selectedProduct) {
                        //             self.filtermeasurement(self.selectedProduct.cat);
                        //         }
                        //    self.showratemodal=false;


                    });
                    
                    $("#employee_name").select2({
                        width: '80%',
                        dropdownAutoWidth: true,
                        placeholder: "Search Employee Here Here...",
                        "language": {
                            "noResults": function () {
                                return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                            }
                        },
                        escapeMarkup: function (markup) {
                            return markup;
                        }
                    }).on('change', function (event) {
                        self.sale.selected_employeeid  = event.target.value;
                        setTimeout(() => { self.$refs.saleRateBtn.focus(); }, 200);
                    });
                    
                    
                     self.$nextTick(() => {
                          
                          if(!self.isEditMode){
                                    setTimeout(() => {   $("#employee_name").select2('open');;}, 200);
                            }
                     });
                    
                    
                    $("#cust_name").select2({
                        width: '80%',
                        dropdownAutoWidth: true,
                        placeholder: "Search Customer Here...",
                        "language": {
                            "noResults": function () {
                                return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                            }
                        },
                        escapeMarkup: function (markup) {
                            return markup;
                        }
                    }).on('change', function (event) {



                        // self.custid  = event.target.value;

                        //     self.getlablevalue(self.custid);



                        

                        var selected_customer = self.customerList.find(item => item.id === event.target.value);
                        if(!selected_customer) return;
                        self.sale.custid = selected_customer.id;
                        self.sale.custcell = selected_customer.cell;
                        self.sale.dob = selected_customer.dob;
                        self.sale.custaddress = selected_customer.address;
                        self.sale.balance = selected_customer.balance;
                        self.sale.date = self.todayDate();;

                        self.prd_select_tag.select2('open');
                    });

                    

                     
                });
            },
            init_stitchingmeasurement(){
                var self=this;
                $("#stitchingmeasurement").select2({
                        width: '100%',
                        placeholder: "Search Stitching Here...",
                        "language": {
                            "noResults": function () {
                                return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                            }
                        },
                        escapeMarkup: function (markup) {
                            return markup;
                        }
                    }).on('change', function (event) {
//  console.log("stitchingmeasurement");
//  console.log(self.filteredMeasurements);
                        self.sm = { lablevalue: [], stitchingid: '', stitching_label: '', lableid: [], label: [] };

                        self.sm.stitchingid = event.target.value;

                        // this.sm.lable[index] = item.label; 
                        self.seletestetchid = event.target.value;

                        let selected_item = self.filteredMeasurements?self.filteredMeasurements.filter(item =>
                            item.id == self.seletestetchid
                        ):[];
                        //    let selected_item = self.seletestetchid;


                             console.log(selected_item);
                        if (selected_item.length > 0) {

                            self.selected_stitch_id = selected_item[0].id;
                            self.sm.stitching_label = selected_item[0].name;



                            if (self.sale_product_list[self.current_index_of_added_product]?.measurements) {
                                console.log("current_index_of_added_product >> "+current_index_of_added_product);
                                console.log(self.sale_product_list[self.current_index_of_added_product]?.measurements);
                            } else {
                                self.getlablevalue(self.seletestetchid);
                            }


                            // self.stichlabels= self.All_stiching_lables.filter(item => 
                            //                 item.stitchingcat === selected_stitch_id
                            //             );

                            // self.stichlabels = (self.All_stiching_lables || []).filter(item => 
                            // item.stitchingcat ===self.selected_stitch_id
                            // );
                        }




                        // //console.log(self.stichlabels);



                    });
            },
            alerty() {
                alert('Hello');
            },
            save() {
                var self = this;
                var selected_cust = 0;
                if(self.Customer.name==''){
                    self.$swal("Customer Name is Required");
                }else if(self.Customer.cell==''){
                    self.$swal("Customer Contact is Required");
                }else if(self.Customer.dob==''){
                    self.$swal("Customer DOB is Required");
                }else if(self.Customer.address==''){
                    self.$swal("Customer Address is Required");
                }else
                {
                    axios.post('addCustomer', this.Customer)
                        .then(response => {
                            var msg = response.data.msg;
                            var isSuccess = response.data.status;
                            
                           
                                

                            if (isSuccess == 1) {
                                self.closeModal();
                                 self.customerList = response.data.list;

                                self.employees = response.data.userDetails;
    
                                selected_cust = response.data.custid;// for default select
    
                                self.employees = response.data.userDetails;
                                self.Customer = { name: '', cell: '', address: '', gst: '' };
                                
                                // window.location.reload();
                            } else
                                self.$swal(msg);
                                
                        }).then(() => {

                            $("#cust_name").select2({
                                width: '80%',
                                dropdownAutoWidth: true,
                                placeholder: "Search Customer Here...",
                                "language": {
                                    "noResults": function () {
                                        return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                    }
                                },
                                escapeMarkup: function (markup) {
                                    return markup;
                                }
                            }).on('change', function (event) {
                                var selected_customer = self.customerList.find(item => item.id === event.target.value);
                                self.sale.custid = selected_customer.id;
                                self.sale.custcell = selected_customer.cell;
                                self.sale.custgst = selected_customer.gst;
                                self.sale.custaddress = selected_customer.address;
                                self.prd_select_tag.select2('open');
                            });

                            $('#cust_name').val(selected_cust);
                            $('#cust_name').trigger('change');
                        })
                        .catch(error => {
                            //console.log('Error on Authentication: ' + error);
                        });
                }
            },
            save_bill() {
                var self = this;
                if (self.sale.custid == '')
                    self.$swal("Please Select Customer...");
                else if (self.sale_product_list.length == 0)
                    self.$swal("Please Select Products...");
                else {
                    const loader = document.getElementById('global-loader');
                    if (loader) loader.style.display = 'flex';
    
                    axios.post('addSalesBill', { invoice_number :self.invoice,edit_sale_id:self.edit_sale_id,washing: self.washing,sale: self.sale, sale_items: JSON.stringify(self.sale_product_list), account: self.account, sm: self.sm,stitch_type:self.stitch_type_for })
                        .then(response => {
                            const loader = document.getElementById('global-loader');
                            if (loader) loader.style.display = 'none';
    
                            var msg = response.data.msg;
                            var isSuccess = response.data.status;
                            self.saleid = response.data.sales_id;
                            // self.productsList=response.data.list;
                            self.employees = response.data.userDetails;
                            self.Customer = { name: '', cell: '', address: '', gst: '' };
                            self.ismeasurement = response.data.ismeasurement;

                            self.$swal(msg);
                            if (isSuccess == 1) {
                                self.closeModal();
                                self.print_invoice();
                             
                                // window.location.reload();
                            }
                        })
                        .catch(error => {
                            //console.log('Error on Authentication: ' + error);
                        });
                }
            },

            getBarcode() {
                var self = this;

                try {
                    if (this.prd.barcode) {
                        if (self.prd.barcode[0] == 0)
                            self.prd.barcode = self.prd.barcode.substring(1);

                        var found_product = self.sale_product_list.find(item => item.barcode === self.prd.barcode);
                        if (found_product) {
                            found_product.qty = found_product.qty + 1;
                        } else {
                            self.selectedProduct = self.productsList.find(item => item.barcode === self.prd.barcode);
                            if (self.selectedProduct) {
                                self.prd = self.selectedProduct;
                                self.prd.prdname = self.selectedProduct.name;
                                self.prd.qty = 1;
                                // self.sale_product_list.push({ ...self.prd });
                            }
                        }
    setTimeout(() => {
                                const input = self.$refs.qty_mtr;
                                input.focus();
                                input.select();
                                }, 300);


                        self.getFinalTotal();
                        // self.prd = [];

                        // setTimeout(() => { self.$refs.barcode.focus() }, 300);  // changed on 26.11.2025
                        
                      

                    }

                } catch (error) {
                    //console.log('Error on Authentication: ' + error);
                }
            },
            remove_item() {

                this.sale_product_list.splice(this.deleteId, 1);
                // alert(this.deleteId);
                this.closeModal();

            },
            addToCart() {
                if ((this.prd.salerate || this.prd.set_rate) && (this.prd.qty > 0 || this.prd.set_qty > 0) && (this.prd.qty_mtr>=0 && this.prd.qty_unit>=0) ) {
                    // this.current_index_of_added_product=this.sale_product_list;
                    this.sale_product_list.push({ ...this.prd });
                    this.prd = {};

                    this.prd_select_tag.select2('open');
                    this.getFinalTotal();
                }

            },


            save_measurement() {

         
                //console.log("Measurement For :-" +   this.selectedProduct.measurementnote);

               // console.log("Stitch Type For:-"+this.current_selected_stitch_type);


                            // if (this.current_selected_stitch_type == 1) {
                            //         const note = this.selectedProduct.measurementnote;

                                   
                            //         const mainPoint = note.mainPoint || '';
                            //         const subPoints = Array.isArray(note.subPoints) ? note.subPoints : [];

                                   
                            //         this.measurement_styel_Array.push({
                            //             mainPoint: mainPoint,
                            //             subPoints: subPoints
                            //         });

                                  
                            //         if (!this.selectedSubPoints) {
                            //             this.selectedSubPoints = {};
                            //         }

                            //         this.selectedSubPoints[mainPoint] = [...subPoints];
                            //     }

                           
                                    // Now you can use mainPointFor and subPointFor
                                 //  console.log("Main:", this.mainPointFor);
                                //  console.log("Sub:", this.subPointFor);



            //   console.log("Assigned measurements:", this.sale_product_list[this.current_index_of_added_product]['measurements'] = { ...this.sm });

                        for (let index = 0; index < this.sale_product_list.length; index++) {
                            const element = this.sale_product_list[index];
                            if(element?.measurements){
                                continue;
                            }
                            if(this.sale_product_list[index].stich_type==this.current_selected_stitch_type){
                            this.sale_product_list[index]['measurements'] = { ...this.sm};
                            this.sale_product_list[index].measurementnote=this.selectedProduct.measurementnote;

                        //   console.log("Updated sale_product_list[", index, "]:", this.sale_product_list[index]);

                           
// sm.stitchingid

                     

                            }

                        }


                // this.sale_product_list[this.current_index_of_added_product]['measurements'] = { ...this.sm};
              
                 if(this.current_selected_stitch_type=="1"){
                 
                    this.temp_shirt={...this.sm };
 
                 //console.log("before inserting " + JSON.stringify(this.temp_shirt));


                }else{
                    
                    this.temp_pant={...this.sm };
                }
 
                     
                    //   //console.log(this.temp_pant);

                this.sm = { lablevalue: [], stitchingid: '', stitching_label: '', lableid: [], label: []};

                // this.selectedProduct={
                //     measurementnote:'',
                // }
                 
                // document.getElementById('plusModal').style.display = 'none';
                // this.showmodel=false;
                $("#plusModal").addClass('hidden');
                this.isMesaurmentModalOpen=true;
                this.isStyleModalOpen=false;
                
                    this.isModalOpen=false;
                // this.$refs.measurement_save_btn.focus();


            },

            filterseletestetchlable(seletestetchid) {
                var self = this;

                axios.post('getFilterMeasurement', { seletestetchid: self.seletestetchid }).then(function (response) {
                    self.filteredlable = response.data.filteredlable;
                });

            },


            // handleInputChange(index, item) {
            // alert("hello");
            //     //console.log(this.sm);
            //     //console.log(item);
            //     item.lablevalue.replace(".","|");//24.05.2025
            //     this.sm.lablevalue[index] = item.lablevalue;
            //     this.sm.lableid[index] = item.id;
            //     this.sm.label[index] = item.lable;

            //     // this.sale_product_list.push(this.current_index_of_added_product)
            //     // this.prd

            // },


            handleInputChange(index, item) {
               // alert("hello");
                //console.log(this.sm);
                //console.log(item);

                // Replace all "." with "|"
                item.lablevalue = item.lablevalue.replace(/\./g, "|");

                // Update your sm object
                this.sm.lablevalue[index] = item.lablevalue;
                this.sm.lableid[index] = item.id;
                this.sm.label[index] = item.lable;
            },









            getlablevalue(seletestetchid) {
             //    alert(seletestetchid);
                // if(t)

                var self = this;
                if (self.sale.custid == 0) {

                    // self.$swal("Select Customer");
                    return;
                } else {
                    self.loading_stich_labels = "Loading labels";
                    axios.post('getcustmeasurement', { id: self.seletestetchid, custid: self.sale.custid }).then(function (response) {
                    //selected_stitch_id  24.05.2025 
                    // axios.post('getcustmeasurement', { id: self.selected_stitch_id, custid: self.sale.custid }).then(function (response) {
                        self.loading_stich_labels = "";

                   //     self.sm = { lablevalue: [], stitchingid: '', stitching_label: '', lableid: [], label: [] };

                            //console.log("after_shirt_lable:-");
                            //console.log(self.temp_shirt);
                            //console.log(response.data?.temp+"  >>  temp_shirt.length"+self.temp_shirt);
                            
                            if(response.data?.temp && (self.temp_shirt?.lableid   || self.temp_pant?.lableid )){
                                
                            //console.log("entered in block if");
                            // self.stichlabels = (self.All_stiching_lables || []).filter(item =>
                            //                                 item.stitchingcat === self.selected_stitch_id
                            //                             );
                         self.stichlabels = response.data.getallcustmeasurement;

                            if (self.stichlabels && self.stichlabels.length > 0) {
                                 console.log("temp_pant");
                                 console.log(self.temp_pant);

                                for (let index = 0; index < self.stichlabels.length; index++) {
                                    const element = self.stichlabels[index];

                                    if(self.current_selected_stitch_type==1 && self.temp_shirt?.lableid && self.temp_shirt?.lableid.length>index){

                     

                                        self.sm.lablevalue[index] = self.temp_shirt.lablevalue[index];
                                         element.lablevalue = self.temp_shirt.lablevalue[index];


                                                                // //console.log(
                                                                //                 `Copying lablevalue[${index}]:`,
                                                                //                 self.temp_shirt.lablevalue[index],
                                                                //                 '->',
                                                                //                 self.sm.lablevalue[index]
                                                                //                 );


                                        self.sm.lableid[index] = self.temp_shirt.lableid[index];
                                    }else if(self.current_selected_stitch_type==2 && self.temp_pant?.lableid &&  self.temp_pant?.lableid.length>index){
                                        self.sm.lablevalue[index] = self.temp_pant.lablevalue[index];
                                        self.sm.lableid[index] = self.temp_pant.lableid[index];
                                    }else{
                                        self.sm.lablevalue[index] = 0;
                                        self.sm.lableid[index] = element.id;
                                    }
                                    self.sm.label[index] = element.lable;

                                }
                            }
                            // else 
                             //console.log("stichlabels.length == 0");
}else{
    //console.log("entered in block else");
                             
                        if (response.data.getallcustmeasurement && response.data.getallcustmeasurement.length > 0) {
                            // self.stichlabels = response.data.getallcustmeasurement;
                        //     console.error("getallcustmeasurement");
                        //     console.error(response.data.getallcustmeasurement);
                          if (self.stitch_type == 1) {
                              self.stichlabels = response.data.getallcustmeasurement.length>=13?response.data.getallcustmeasurement:self.normalizeArray(response.data.getallcustmeasurement, 13);
                            
                        } else {
                            self.stichlabels = response.data.getallcustmeasurement.length>=8?response.data.getallcustmeasurement: self.normalizeArray(response.data.getallcustmeasurement, 8);
                        }
                                
                            if (self.stichlabels && self.stichlabels.length > 0) {
                                for (let index = 0; index < self.stichlabels.length; index++) {
                                    const element = self.stichlabels[index];
                                    self.sm.lablevalue[index] = element.lablevalue;
                                    self.sm.lableid[index] = element.lableid;
                                    self.sm.label[index] = element.lable;

                                }
                            }
                        console.error("stichlabels");
                        console.error(self.stichlabels);

                        } else {
                            self.stichlabels = (self.All_stiching_lables || []).filter(item =>
                                item.stitchingcat === self.selected_stitch_id
                            );
                            //console.log("self.selected_stitch_id"+self.selected_stitch_id);
                            //console.log("self.temp_shirt"+self.temp_shirt);

                            if (self.stichlabels && self.stichlabels.length > 0) {
                                for (let index = 0; index < self.stichlabels.length; index++) {
                                    const element = self.stichlabels[index];
                                    if(self.selected_stitch_id==1 && self.temp_shirt.length>index){
                                        self.sm.lablevalue[index] = self.temp_shirt.lablevalue[index];
                                        self.sm.lableid[index] = self.temp_shirt.lableid[index];
                                    }else if(self.selected_stitch_id==2 && self.temp_pant.length>index){
                                        self.sm.lablevalue[index] = self.temp_pant.lablevalue[index];
                                        self.sm.lableid[index] = self.temp_pant.lableid[index];
                                    }else{
                                        self.sm.lablevalue[index] = 0;
                                        self.sm.lableid[index] = element.id;
                                    }
                                    self.sm.label[index] = element.lable;

                                }
                            }
                        }
                    }



                    }).then(() => {
                        //console.log(self.stichlabels);
                            $('#measurement_inputs').find('input:visible:enabled:first').focus();
                    });


                }




            },

 normalizeArray(arr, size) {
    arr = arr || [];

    while (arr.length < size) {
        arr.push({ labelvalue: "" });   // Vue expects object, not 0
    }

    return arr;
},

           reset_measurement() {
            var self=this;
                // Reset the measurement object
                this.sm = {
                    lablevalue: [],
                    stitchingid: '',
                    stitching_label: '',
                    lableid: [],
                    label: []
                };
                
               
                this.stichlabels = [];
                
               
                this.already_selected_measurement_label = "";
                
               
                if (this.sale_product_list[this.current_index_of_added_product]?.measurements) {
                    delete this.sale_product_list[this.current_index_of_added_product].measurements;
                }
                
               
                $("#stitchingmeasurement").val("").trigger("change");
                
                
                this.$swal("Measurements reset successfully");

                self.getBasics();
},


            showstylemodal(){
 
                    var self=this;
                     $("#showstylemodal").removeClass('hidden');
                     this.isStyleModalOpen=true;
                    this.isModalOpen=true;
                    
                      const styleEl = self.$refs.style_open;
                          if (styleEl && styleEl.focus) {
                            styleEl.focus();
                          }
                        
                    self.$nextTick(() => {
                      const inputs = (Array.isArray(self.$refs.style_open) ? self.$refs.style_open[0] : self.$refs.style_open).querySelectorAll('input[type="checkbox"]');
                      if (inputs.length) inputs[0].focus();
                    });

            },


            getItemStyle(index) {
    if (index === 0) {
        return {
            flex: '0 0 100%'  // Full width for first item
        }
    }
    else if (index > 0 && index < 4) {
        return {
            display: 'contents' // Full width for first item
        }
    }
    else if (index > 3 && index < 7) {
        return {
            width: '-webkit-fill-available !important',
            display: 'contents', // Full width for first item
        }
    }
    else if (index === 7) {
        return {
            flex: '0 0 100%'  // Full width for first item
        }
    }
    else if (index === 12) {
        return {
            flex: '0 0 100%'  // Full width for first item
        }
    }
    else if (index === 13) {
        return {
            flex: '0 0 100%'  // Full width for first item
        }
    }
    return {
        display: 'contents' // Three items per row, accounting for gap
    };
},


focusNextIp(currentIndex) {
  const nextInput = this.$refs['input' + (currentIndex + 1)];
  if (nextInput)   {
    nextInput.focus();
  }else{
      
     this.$refs['style_btn'].focus();// + (currentIndex + 1)];
      
  }
},

saveSelections() {

  
  this.closeStyleModal();
   this.$refs['save_measurement_button'].focus();

},
 handleEnterKey() {
    const focused = document.activeElement;
    if (focused && focused.type === 'checkbox') {
      // Toggle the checkbox's checked state
      focused.checked = !focused.checked;

      
      const mainPoint = focused.dataset.mainPoint;
      const subPoint = focused.dataset.subPoint;
// //console.log(subPoint);
      if (mainPoint && subPoint) {
        this.toggleSelection(mainPoint, subPoint);
        
      }
    }
  },


    toggleSelection(mainPoint, subPoint) {

        this.mainPointFor = mainPoint;    
        this.subPointFor = subPoint;


          
          //console.log("toggleSelection");
          
          
        const key = `${mainPoint}:${subPoint}`;
        if (this.selectedSubPoints.has(key)) {
        this.selectedSubPoints.delete(key);
        } else {
        this.selectedSubPoints.add(key);
        }
        // //console.log(this.selectedProduct);
        // Update measurementnote with only subPoint names (not keys)
      this.selectedProduct.measurementnote = Array.from(this.selectedSubPoints).join(', ');

    },
    //29.05.205
      toggleSelectionPant(mainPoint, subPoint) {
          
          //console.log("toggleSelectionPant");
          
          
        const key = `${mainPoint}:${subPoint}`;
        if (this.selectedSubPointsPants.has(key)) {
            this.selectedSubPointsPants.delete(key);
            } else {
            this.selectedSubPointsPants.add(key);
            }
        
        // Update measurementnote with only subPoint names (not keys)
        this.selectedProduct.measurementnote = Array.from(this.selectedSubPointsPants)
        .map(item => item.split(':')[1]) // extract subPoint only
        .join(', ');

  




    },
    
    
    isChecked(mainPoint, subPoint) {
        return this.selectedSubPoints.has(`${mainPoint}:${subPoint}`);
    },
    
     isCheckedForPant(mainPoint, subPoint) {
        return this.selectedSubPointsPants.has(`${mainPoint}:${subPoint}`);
    },
    
    //26.05.2025
    
   handleArrowKeys(event) {
       
       if (event.key === "Escape") {
            if(this.isStyleModalOpen){
                this.isStyleModalOpen=false;
                
                $("#showstylemodal").addClass('hidden');
                 setTimeout(() => { $("#delv_on_note").focus();}, 300);
                // $("#showratetypemodal").addClass('hidden');
                return;
            }else   if(this.isStyleModalOpen){
               this.closeModal();
                return;
            }
           //   this.closeModal();
             // return;
            }
             if (event.key === "F2") {
              this.save_bill();
              return;
            }
            
         if (event.key === "F1") {
             event.preventDefault();
               $('#cust_name').select2('close');
               $("#editModal").removeClass('hidden');
                setTimeout(() => { $("#first_input").focus();}, 300);
              return;
            }
        
          
              
      
         if (document.querySelector('.select2-container--open')) {
            return;
          }else{
                //console.log('select2-container', "no ");
          }
          
          
      

   // focused checkbox not found in lists

    if (event.key === 'ArrowRight') {
        if(this.stitch_type_for==0){
            this.$refs.saleRateBtn.focus();
            return;
        }
            if(this.isModalOpen && this.isStyleModalOpen){
                
                
                 const styleOpenRefs = this.$refs.style_open; // this is an array of UL elements

                    if (!styleOpenRefs || !styleOpenRefs.length) return;
                
                    // Find which UL container the focused checkbox belongs to
                    let currentListIndex = -1;
                    let inputsInCurrentList = null;
                    let activeIndex = -1;
                    
                
                    for (let i = 0; i < styleOpenRefs.length; i++) {
                      const inputs = styleOpenRefs[i].querySelectorAll('input[type="checkbox"]');
                      const activeEl = document.activeElement;
                      const idx = Array.from(inputs).indexOf(activeEl);
                      if (idx !== -1) {
                        currentListIndex = i;
                        inputsInCurrentList = inputs;
                        activeIndex = idx;
                        break;
                      }
                    }
                    if (currentListIndex === -1 || !inputsInCurrentList) return; 
                     
                
                
                
                  if (activeIndex < inputsInCurrentList.length - 1) {
                    inputsInCurrentList[activeIndex + 1].focus();
                  } 
                  // else move to first checkbox of next list if exists
                  else if (currentListIndex < styleOpenRefs.length - 1) {
                    const nextListInputs = styleOpenRefs[currentListIndex + 1].querySelectorAll('input[type="checkbox"]');
                    if (nextListInputs.length) nextListInputs[0].focus();
                  }else{
                      this.$refs.save_style_btn.focus();
                  }
        }
    } 
    else if (event.key === 'ArrowLeft') {
        if(this.stitch_type_for==0){
            this.$refs.stichRateBtn.focus();
            return;
        }
        
     if(this.isModalOpen && this.isStyleModalOpen){
         
          const styleOpenRefs = this.$refs.style_open; // this is an array of UL elements

                    if (!styleOpenRefs || !styleOpenRefs.length) return;
                
                    // Find which UL container the focused checkbox belongs to
                    let currentListIndex = -1;
                    let inputsInCurrentList = null;
                    let activeIndex = -1;
                
                    for (let i = 0; i < styleOpenRefs.length; i++) {
                      const inputs = styleOpenRefs[i].querySelectorAll('input[type="checkbox"]');
                      const activeEl = document.activeElement;
                      const idx = Array.from(inputs).indexOf(activeEl);
                      if (idx !== -1) {
                        currentListIndex = i;
                        inputsInCurrentList = inputs;
                        activeIndex = idx;
                        break;
                      }
                    }
                    
                    if (currentListIndex === -1 || !inputsInCurrentList) return; 
                    
                    
          if (activeIndex > 0) {
            inputsInCurrentList[activeIndex - 1].focus();
          } 
          // else move to last checkbox of previous list if exists
          else if (currentListIndex > 0) {
            const prevListInputs = styleOpenRefs[currentListIndex - 1].querySelectorAll('input[type="checkbox"]');
            if (prevListInputs.length) prevListInputs[prevListInputs.length - 1].focus();
          }else{
               this.$refs.save_style_btn.focus();
          }
         }else{
              console.warn('e.close :', "isStyleModalOpen");
         }
    }
    else if (event.key === 'ArrowDown') {
       
        //   alert("hello");
      if(this.isModalOpen && this.isStyleModalOpen){
                        const styleOpenRefs = this.$refs.style_open; // this is an array of UL elements
                
                                    if (!styleOpenRefs || !styleOpenRefs.length) return;
                                
                                    // Find which UL container the focused checkbox belongs to
                                    let currentListIndex = -1;
                                    let inputsInCurrentList = null;
                                    let activeIndex = -1;
                                
                                    for (let i = 0; i < styleOpenRefs.length; i++) {
                                      const inputs = styleOpenRefs[i].querySelectorAll('input[type="checkbox"]');
                                      const activeEl = document.activeElement;
                                      const idx = Array.from(inputs).indexOf(activeEl);
                                      if (idx !== -1) {
                                        currentListIndex = i;
                                        inputsInCurrentList = inputs;
                                        activeIndex = idx;
                                        break;
                                      }
                                    }
                                    
                                    if (currentListIndex === -1 || !inputsInCurrentList) {
                                         return; }
                                    
                                    
                            if (currentListIndex < styleOpenRefs.length - 1) {
                            const prevListInputs = styleOpenRefs[currentListIndex + 1].querySelectorAll('input[type="checkbox"]');
                            if (prevListInputs.length) prevListInputs[0].focus();
                          }
     }else{ 
             if(this.isModalOpen)
                return;
            const rows = this.$refs['selected_product'];
            if (!rows) return;
        
            const rowArray = Array.isArray(rows) ? rows : [rows];
          
              if(!this.isModalOpen) {
                if (this.currentFocusedIndex < rowArray.length - 1) {
                    this.currentFocusedIndex++;
                  }else{
                     console.warn('e.key :', "down");
                    //  console.log(this.$refs.discountInput);
                    // setTimeout(() => { this.$refs.discountInput.focus();this.$refs.discountInput.select(); }, 200)
                    //changed after washing on 13.11.2025 
                     setTimeout(() => { this.$refs.washing_qty.focus();this.$refs.washing_qty.select(); }, 200)
                              
                          
                  }
                  this.focusRow(rowArray, this.currentFocusedIndex);
              }
               
           
     }
    }
    else if (event.key === 'ArrowUp') {

      
      if(this.isModalOpen || this.isStyleModalOpen){
                   const styleOpenRefs = this.$refs.style_open; // this is an array of UL elements
        
                            if (!styleOpenRefs || !styleOpenRefs.length) return;
                        
                            // Find which UL container the focused checkbox belongs to
                            let currentListIndex = -1;
                            let inputsInCurrentList = null;
                            let activeIndex = -1;
                        
                            for (let i = 0; i < styleOpenRefs.length; i++) {
                              const inputs = styleOpenRefs[i].querySelectorAll('input[type="checkbox"]');
                              const activeEl = document.activeElement;
                              const idx = Array.from(inputs).indexOf(activeEl);
                              if (idx !== -1) {
                                currentListIndex = i;
                                inputsInCurrentList = inputs;
                                activeIndex = idx;
                                break;
                              }
                            }
                            
                            if (currentListIndex === -1 || !inputsInCurrentList) return; 
                            
                            
                 if (currentListIndex >0) {
                    const nextListInputs = styleOpenRefs[currentListIndex - 1].querySelectorAll('input[type="checkbox"]');
                    if (nextListInputs.length) nextListInputs[0].focus();
                  }else{
                      this.$refs.save_style_btn.focus();
                  }
      }else{
          if(this.isModalOpen)
                return;
            const rows = this.$refs['selected_product'];
            if (!rows) return;
        
            const rowArray = Array.isArray(rows) ? rows : [rows];
              
              if(!this.isModalOpen){ 
                  if (this.currentFocusedIndex > 0) {
                    this.currentFocusedIndex--;
                  }
                  this.focusRow(rowArray, this.currentFocusedIndex);
              }
         
      }  
      
       
                        
                        
    // }
    }
   
  },
  
//    handleShortcut(e) {
//         console.warn('e.key :', e.key);
        
       
//        if (e.key === "Escape"){
//             // $("#plusModal").addClass('hidden');
//             //     $("#showstylemodal").addClass('hidden');
//              this.closeModal();
//              return;
//         }
       
//         if(this.isModalOpen)
//          return;
         
        
      
  
//     if ( (e.key=== 'ArrowDown' || e.key=== 'ArrowUp')) {
//         e.preventDefault(); // Optional: prevent browser's default
//        const rowRef = this.$refs['selected_product0'];
        
//           // It might be an array if used in v-for
//           const row = Array.isArray(rowRef) ? rowRef[0] : rowRef;
        
//           if (row && typeof row.focus === 'function') {
//             row.focus();
//           } else {
//             console.warn('Row is not focusable:', row);
//           }
//     }
//   }



handleShortcut(e) {
  
  

    

    // const rows = this.$refs['selected_product'];
    // if (!rows) return;

    // // Convert to array in case it's a single element
    // const rowArray = Array.isArray(rows) ? rows : [rows];

    // if (e.key === 'ArrowDown') {
    //   e.preventDefault();
    //   if(!this.isModalOpen) {
    //     if (this.currentFocusedIndex < rowArray.length - 1) {
    //         this.currentFocusedIndex++;
    //       }
    //       this.focusRow(rowArray, this.currentFocusedIndex);
    //   }
    // }

    // if (e.key === 'ArrowUp') {
    //   e.preventDefault();
    //   if(!this.isModalOpen){ 
    //       if (this.currentFocusedIndex > 0) {
    //         this.currentFocusedIndex--;
    //       }
    //       this.focusRow(rowArray, this.currentFocusedIndex);
    //   }
    // }
  },

  focusRow(rowArray, index) {
    const row = rowArray[index];
    if (row && typeof row.focus === 'function') {
      row.focus();
    } else {
      console.warn('Row is not focusable:', row);
    }
  }
},

















  
    }
</script>

